import { Component, Input, OnChanges, OnInit } from "@angular/core";
import { NgClass, NgIf } from "@angular/common";
import { GetProductDetailQuery, GetProductVariantDetailQuery } from '../../common/gql/graphql';

@Component({
    selector: 'kb-special-price-badge',
    templateUrl: 'special-price-badge.component.html',
    standalone: true,
    imports: [
        NgIf,
        NgClass
    ]
})
export class SpecialPriceBadgeComponent implements OnChanges {
    @Input() selectedVariant:
        | NonNullable<GetProductDetailQuery['product']>['variants'][number]
        | NonNullable<GetProductVariantDetailQuery['productVariant']>;

    @Input() badgeClass = '';

    blackFriday = false;
    januarySale = false;
    ngOnChanges() {
        this.blackFriday = !!this.selectedVariant.facetValues.find(facet => facet.code === 'black-friday');
        this.januarySale = !!this.selectedVariant.facetValues.find(facet => facet.code === 'january-sale');
    }
}
